export default "__VITE_ASSET__CIjSD4LB__"